import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'
import Editor from '@hugerte/hugerte-vue'
import { useHugeRTE, getEditorInit } from '../../foundation/js/loadHugeRTE'

const options = formFieldCommonOptions('FormInputRichText', {})

options.components.Editor = Editor

const baseSetup = options.setup
options.setup = (props, ctx) => {
    const base = baseSetup(props, ctx)
    const { editorReady } = useHugeRTE()

    const editorInit = getEditorInit({
        placeholder: props.placeholder,
        plugins: 'emoticons autoresize autolink',
        toolbar: 'emoticons',
        toolbar_location: 'bottom',
        menubar: false,
        statusbar: false,
        min_height: 200,
        autoresize_bottom_margin: 30,
        formats: {
            bold: {},
            italic: {},
            underline: {}
        }
    })

    const onEditorUpdate = (value) => {
        base.localValue.value = value
        ctx.emit('update:modelValue', value)
    }

    return {
        ...base,
        editorReady,
        editorInit,
        onEditorUpdate
    }
}

export default options
